<template>
    <rkm-overlay>
        <rkm-layout-body title="Reterritorialização">
            <template v-slot:actions>
                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :key="key"
                    @model-load="handleModelLoaded"
                    @save="handleSave()"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from "@/components/atencao-basica/reterritorializacao/Form";

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    data: () => ({
        key: 1,
        model: null,
        unwatchers: {
            unwatchModel: null
        },
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
            'setLoading',
            'unsetLoading',
        ]),
        handleSave() {
            this.unsetShowExitFormConfirmation()

            this.key++
        },
        handleModelLoaded(model) {
            this.model = model

            this.unwatchModel = this.$watch('model', {
                deep: true,
                handler() {
                    this.setShowExitFormConfirmation()
                    this.unwatchModel()
                }
            })
        },
    },
}
</script>